import { render, staticRenderFns } from "./ReplacementEditPage.vue?vue&type=template&id=ffb71238&"
import script from "./ReplacementEditPage.vue?vue&type=script&lang=ts&"
export * from "./ReplacementEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports